import { useState } from 'react';
import { ListingClient, ListingDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useListingApi = () => {
    const apiClient = new ListingClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: ListingDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createListing(data);
        } catch (err: any) {
            setError(err.message || 'Error creating Listing');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: ListingDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateListing(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating Listing');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getListingById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching Listing');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchListings(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching Listings');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteListing(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting Listing');
        } finally {
            setIsLoading(false);
        }
    };

    const searchByProximity = async (latitude?: number, longitude?: number, limit?: number, name?: string, listingTypeId?: string | null) => {
        setIsLoading(true);
        try {
            return await apiClient.searchListingsByProximity(
                latitude ?? null,
                longitude ?? null,
                limit ?? null,
                name ?? null,
                listingTypeId ?? null
            );
        } catch (err: any) {
            setError(err.message || 'Error searching Listings by proximity');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, searchByProximity, isLoading, error };
};